module.exports = __webpack_public_path__ + "img/code6.2b83de1a.jpg";